<template>
  <base-section id="gallery">
    <base-section-heading title="Галерея">
    </base-section-heading>
    <v-container>
      <v-row class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
        <v-col
          v-for="(image, i) in list()"
          :key="'d'+i"
          cols="2"
          class="hidden-xs-only"
        >
          <base-img
            :src="require('@/assets' + image)"
            color="grey lighten-1"
            max-width="200"
            max-height="167"
            tile
            class="image"
            @click="index = i"
          />
        </v-col>
        <v-col
          v-for="(image, i) in list()"
          :key="'m'+i"
          cols="5"
          class="hidden-sm-and-up"
        >
          <base-img
            :src="require('@/assets' + image)"
            color="grey lighten-1"
            max-width="160"
            height="100"
            tile
            class="image"
            @click="index = i"
          />
        </v-col>
        <vue-gallery-slideshow
          :images="images"
          :index="index"
          @close="index = null"
        />
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import VueGallerySlideshow from 'vue-gallery-slideshow'
  export default {
    name: 'SectionBlockGallery',
    components: {
      VueGallerySlideshow,
    },
    methods: {
      list () {
        const newlist = []
        for (let i = 0; i < 24; i++) {
          newlist.push(this.images[i])
        }
        return newlist
      },
    },
    data: () => ({
      images: [
        '/gallery/gallery-1.jpg',
        '/gallery/gallery-2.jpg',
        '/gallery/gallery-2.jpg',
        '/gallery/gallery-3.jpg',
        '/gallery/gallery-4.jpg',
        '/gallery/gallery-5.jpg',
        '/gallery/gallery-6.jpg',
        '/gallery/gallery-7.jpg',
        '/gallery/gallery-8.jpg',
        '/gallery/gallery-9.jpg',
        '/gallery/gallery-10.jpg',
        '/gallery/gallery-11.jpg',
        '/gallery/gallery-12.jpg',
        '/gallery/gallery-13.jpg',
        '/gallery/gallery-14.jpg',
        '/gallery/gallery-15.jpg',
        '/gallery/gallery-16.jpg',
        '/gallery/gallery-17.jpg',
        '/gallery/gallery-18.jpg',
        '/gallery/gallery-19.jpg',
        '/gallery/gallery-20.jpg',
        '/gallery/gallery-21.jpg',
        '/gallery/gallery-22.jpg',
        '/gallery/gallery-23.jpg',
        '/gallery/gallery-24.jpg',
        '/gallery/gallery-25.jpg',
        '/gallery/gallery-26.jpg',
        '/gallery/gallery-27.jpg',
        '/gallery/gallery-28.jpg',
        '/gallery/gallery-29.jpg',
        '/gallery/gallery-30.jpg',
        '/gallery/gallery-31.jpg',
        '/gallery/gallery-32.jpg',
        '/gallery/gallery-33.jpg',
        '/gallery/gallery-34.jpg',
        '/gallery/gallery-35.jpg',
        '/gallery/gallery-36.jpg',
        '/gallery/gallery-37.jpg',
        '/gallery/gallery-38.jpg',
        '/gallery/gallery-39.jpg',
        '/gallery/gallery-40.jpg',
        '/gallery/gallery-41.jpg',
        '/gallery/gallery-42.jpg',
        '/gallery/gallery-43.jpg',
        '/gallery/gallery-44.jpg',
        '/gallery/gallery-45.jpg',
        '/gallery/gallery-46.jpg',
        '/gallery/gallery-47.jpg',
        '/gallery/gallery-48.jpg',
        '/gallery/gallery-49.jpg',
        '/gallery/gallery-50.jpg',
        '/gallery/gallery-51.jpg',
        '/gallery/gallery-52.jpg',
        '/gallery/gallery-53.jpg',
        '/gallery/gallery-54.jpg',
        '/gallery/gallery-55.jpg',
        '/gallery/gallery-56.jpg',
        '/gallery/gallery-57.jpg',
        '/gallery/gallery-58.jpg',
        '/gallery/gallery-59.jpg',
        '/gallery/gallery-60.jpg',
        '/gallery/gallery-61.jpg',
        '/gallery/gallery-62.jpg',
        '/gallery/gallery-63.jpg',
        '/gallery/gallery-64.jpg',
        '/gallery/gallery-65.jpg',
        '/gallery/gallery-66.jpg',
        '/gallery/gallery-67.jpg',
        '/gallery/gallery-68.jpg',
        '/gallery/gallery-69.jpg',
        '/gallery/gallery-70.jpg',
        '/gallery/gallery-71.jpg',
        '/gallery/gallery-72.jpg',
        '/gallery/gallery-73.jpg',
        '/gallery/gallery-74.jpg',
        '/gallery/gallery-75.jpg',
        '/gallery/gallery-76.jpg',
        '/gallery/gallery-77.jpg',
        '/gallery/gallery-78.jpg',
        '/gallery/gallery-79.jpg',
        '/gallery/gallery-80.jpg',
        '/gallery/gallery-81.jpg',
        '/gallery/gallery-82.jpg',
        '/gallery/gallery-83.jpg',
        '/gallery/gallery-84.jpg',
        '/gallery/gallery-85.jpg',
        '/gallery/gallery-86.jpg',
        '/gallery/gallery-87.jpg',
        '/gallery/gallery-88.jpg',
        '/gallery/gallery-89.jpg',
        '/gallery/gallery-90.jpg',
        '/gallery/gallery-91.jpg',
        '/gallery/gallery-92.jpg',
        '/gallery/gallery-93.jpg',
        '/gallery/gallery-94.jpg',
        '/gallery/gallery-95.jpg',
        '/gallery/gallery-96.jpg',
        '/gallery/gallery-97.jpg',
        '/gallery/gallery-98.jpg',
        '/gallery/gallery-99.jpg',
        '/gallery/gallery-100.jpg',
        '/gallery/gallery-101.jpg',
        '/gallery/gallery-102.jpg',
        '/gallery/gallery-103.jpg',
        '/gallery/gallery-104.jpg',
        '/gallery/gallery-105.jpg',
        '/gallery/gallery-106.jpg',
        '/gallery/gallery-107.jpg',
        '/gallery/gallery-108.jpg',
        '/gallery/gallery-109.jpg',
        '/gallery/gallery-110.jpg',
        '/gallery/gallery-111.jpg',
        '/gallery/gallery-112.jpg',
        '/gallery/gallery-113.jpg',
        '/gallery/gallery-114.jpg',
        '/gallery/gallery-115.jpg',
        '/gallery/gallery-116.jpg',
        '/gallery/gallery-117.jpg',
        '/gallery/gallery-118.jpg',
        '/gallery/gallery-119.jpg',
        '/gallery/gallery-120.jpg',
        '/gallery/gallery-121.jpg',
        '/gallery/gallery-122.jpg',
        '/gallery/gallery-123.jpg',
        '/gallery/gallery-124.jpg',
        '/gallery/gallery-125.jpg',
        '/gallery/gallery-126.jpg',
        '/gallery/gallery-127.png',
        '/gallery/gallery-128.png',
        '/gallery/gallery-129.jpg',
        '/gallery/gallery-130.jpg',
        '/gallery/gallery-131.png',
        '/gallery/gallery-132.png',
        '/gallery/gallery-133.jpg',
        '/gallery/gallery-134.jpg',
        '/gallery/gallery-135.jpg',
        '/gallery/gallery-136.jpg',
        '/gallery/gallery-137.jpg',
        '/gallery/gallery-138.png',
        '/gallery/gallery-139.png',
        '/gallery/gallery-140.jpg',
        '/gallery/gallery-141.jpg',
        '/gallery/gallery-142.jpg',
        '/gallery/gallery-143.jpg',
        '/gallery/gallery-144.jpg',
        '/gallery/gallery-145.jpg',
        '/gallery/gallery-146.jpg',
        '/gallery/gallery-147.jpg',
        '/gallery/gallery-148.jpg',
        '/gallery/gallery-149.jpg',
        '/gallery/gallery-150.jpg',
        '/gallery/gallery-151.jpg',
        '/gallery/gallery-152.jpg',
        '/gallery/gallery-153.jpg',
        '/gallery/gallery-154.jpg',
        '/gallery/gallery-155.jpg',
        '/gallery/gallery-156.jpg',
        '/gallery/gallery-157.jpg',
        '/gallery/gallery-158.jpg',
        '/gallery/gallery-159.jpg',
        '/gallery/gallery-160.jpg',
        '/gallery/gallery-161.jpt',
      ],
      index: null,
    }),
  }
</script>
